// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file chat-message.proto (syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2'
import { enumDesc, fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2'
import type { ImageFormat, MessageType } from './enums_pb'
import { file_enums } from './enums_pb'
import type { ContactRequestPropagatedState } from './contact_pb'
import { file_contact } from './contact_pb'
import type { Shard } from './shard_pb'
import { file_shard } from './shard_pb'
import type { Message } from '@bufbuild/protobuf'

/**
 * Describes the file chat-message.proto.
 */
export const file_chat_message: GenFile =
  /*@__PURE__*/
  fileDesc(
    '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',
    [file_enums, file_contact, file_shard],
  )

/**
 * @generated from message StickerMessage
 */
export type StickerMessage = Message<'StickerMessage'> & {
  /**
   * @generated from field: string hash = 1;
   */
  hash: string

  /**
   * @generated from field: int32 pack = 2;
   */
  pack: number
}

/**
 * Describes the message StickerMessage.
 * Use `create(StickerMessageSchema)` to create a new message.
 */
export const StickerMessageSchema: GenMessage<StickerMessage> =
  /*@__PURE__*/
  messageDesc(file_chat_message, 0)

/**
 * @generated from message ImageMessage
 */
export type ImageMessage = Message<'ImageMessage'> & {
  /**
   * @generated from field: bytes payload = 1;
   */
  payload: Uint8Array

  /**
   * @generated from field: ImageFormat format = 2;
   */
  format: ImageFormat

  /**
   * @generated from field: string album_id = 3;
   */
  albumId: string

  /**
   * @generated from field: uint32 width = 4;
   */
  width: number

  /**
   * @generated from field: uint32 height = 5;
   */
  height: number

  /**
   * @generated from field: uint32 album_images_count = 6;
   */
  albumImagesCount: number
}

/**
 * Describes the message ImageMessage.
 * Use `create(ImageMessageSchema)` to create a new message.
 */
export const ImageMessageSchema: GenMessage<ImageMessage> =
  /*@__PURE__*/
  messageDesc(file_chat_message, 1)

/**
 * @generated from message AudioMessage
 */
export type AudioMessage = Message<'AudioMessage'> & {
  /**
   * @generated from field: bytes payload = 1;
   */
  payload: Uint8Array

  /**
   * @generated from field: AudioMessage.AudioType type = 2;
   */
  type: AudioMessage_AudioType

  /**
   * @generated from field: uint64 duration_ms = 3;
   */
  durationMs: bigint
}

/**
 * Describes the message AudioMessage.
 * Use `create(AudioMessageSchema)` to create a new message.
 */
export const AudioMessageSchema: GenMessage<AudioMessage> =
  /*@__PURE__*/
  messageDesc(file_chat_message, 2)

/**
 * @generated from enum AudioMessage.AudioType
 */
export enum AudioMessage_AudioType {
  /**
   * @generated from enum value: UNKNOWN_AUDIO_TYPE = 0;
   */
  UNKNOWN_AUDIO_TYPE = 0,

  /**
   * @generated from enum value: AAC = 1;
   */
  AAC = 1,

  /**
   * @generated from enum value: AMR = 2;
   */
  AMR = 2,
}

/**
 * Describes the enum AudioMessage.AudioType.
 */
export const AudioMessage_AudioTypeSchema: GenEnum<AudioMessage_AudioType> =
  /*@__PURE__*/
  enumDesc(file_chat_message, 2, 0)

/**
 * @generated from message EditMessage
 */
export type EditMessage = Message<'EditMessage'> & {
  /**
   * @generated from field: uint64 clock = 1;
   */
  clock: bigint

  /**
   * Text of the message
   *
   * @generated from field: string text = 2;
   */
  text: string

  /**
   * @generated from field: string chat_id = 3;
   */
  chatId: string

  /**
   * @generated from field: string message_id = 4;
   */
  messageId: string

  /**
   * Grant for community edit messages
   *
   * @generated from field: bytes grant = 5 [deprecated = true];
   * @deprecated
   */
  grant: Uint8Array

  /**
   * The type of message (public/one-to-one/private-group-chat)
   *
   * @generated from field: MessageType message_type = 6;
   */
  messageType: MessageType

  /**
   * @generated from field: ChatMessage.ContentType content_type = 7;
   */
  contentType: ChatMessage_ContentType

  /**
   * @generated from field: repeated UnfurledLink unfurled_links = 8;
   */
  unfurledLinks: UnfurledLink[]

  /**
   * @generated from field: UnfurledStatusLinks unfurled_status_links = 9;
   */
  unfurledStatusLinks?: UnfurledStatusLinks
}

/**
 * Describes the message EditMessage.
 * Use `create(EditMessageSchema)` to create a new message.
 */
export const EditMessageSchema: GenMessage<EditMessage> =
  /*@__PURE__*/
  messageDesc(file_chat_message, 3)

/**
 * @generated from message DeleteMessage
 */
export type DeleteMessage = Message<'DeleteMessage'> & {
  /**
   * @generated from field: uint64 clock = 1;
   */
  clock: bigint

  /**
   * @generated from field: string chat_id = 2;
   */
  chatId: string

  /**
   * @generated from field: string message_id = 3;
   */
  messageId: string

  /**
   * Grant for community delete messages
   *
   * @generated from field: bytes grant = 4 [deprecated = true];
   * @deprecated
   */
  grant: Uint8Array

  /**
   * The type of message (public/one-to-one/private-group-chat)
   *
   * @generated from field: MessageType message_type = 5;
   */
  messageType: MessageType

  /**
   * @generated from field: string deleted_by = 6;
   */
  deletedBy: string
}

/**
 * Describes the message DeleteMessage.
 * Use `create(DeleteMessageSchema)` to create a new message.
 */
export const DeleteMessageSchema: GenMessage<DeleteMessage> =
  /*@__PURE__*/
  messageDesc(file_chat_message, 4)

/**
 * @generated from message SyncDeleteForMeMessage
 */
export type SyncDeleteForMeMessage = Message<'SyncDeleteForMeMessage'> & {
  /**
   * @generated from field: uint64 clock = 1;
   */
  clock: bigint

  /**
   * @generated from field: string message_id = 2;
   */
  messageId: string
}

/**
 * Describes the message SyncDeleteForMeMessage.
 * Use `create(SyncDeleteForMeMessageSchema)` to create a new message.
 */
export const SyncDeleteForMeMessageSchema: GenMessage<SyncDeleteForMeMessage> =
  /*@__PURE__*/
  messageDesc(file_chat_message, 5)

/**
 * @generated from message DiscordMessage
 */
export type DiscordMessage = Message<'DiscordMessage'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * @generated from field: string type = 2;
   */
  type: string

  /**
   * @generated from field: string timestamp = 3;
   */
  timestamp: string

  /**
   * @generated from field: string timestampEdited = 4;
   */
  timestampEdited: string

  /**
   * @generated from field: string content = 5;
   */
  content: string

  /**
   * @generated from field: DiscordMessageAuthor author = 6;
   */
  author?: DiscordMessageAuthor

  /**
   * @generated from field: DiscordMessageReference reference = 7;
   */
  reference?: DiscordMessageReference

  /**
   * @generated from field: repeated DiscordMessageAttachment attachments = 8;
   */
  attachments: DiscordMessageAttachment[]
}

/**
 * Describes the message DiscordMessage.
 * Use `create(DiscordMessageSchema)` to create a new message.
 */
export const DiscordMessageSchema: GenMessage<DiscordMessage> =
  /*@__PURE__*/
  messageDesc(file_chat_message, 6)

/**
 * @generated from message DiscordMessageAuthor
 */
export type DiscordMessageAuthor = Message<'DiscordMessageAuthor'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * @generated from field: string name = 2;
   */
  name: string

  /**
   * @generated from field: string discriminator = 3;
   */
  discriminator: string

  /**
   * @generated from field: string nickname = 4;
   */
  nickname: string

  /**
   * @generated from field: string avatarUrl = 5;
   */
  avatarUrl: string

  /**
   * @generated from field: bytes avatarImagePayload = 6;
   */
  avatarImagePayload: Uint8Array

  /**
   * @generated from field: string localUrl = 7;
   */
  localUrl: string
}

/**
 * Describes the message DiscordMessageAuthor.
 * Use `create(DiscordMessageAuthorSchema)` to create a new message.
 */
export const DiscordMessageAuthorSchema: GenMessage<DiscordMessageAuthor> =
  /*@__PURE__*/
  messageDesc(file_chat_message, 7)

/**
 * @generated from message DiscordMessageReference
 */
export type DiscordMessageReference = Message<'DiscordMessageReference'> & {
  /**
   * @generated from field: string messageId = 1;
   */
  messageId: string

  /**
   * @generated from field: string channelId = 2;
   */
  channelId: string

  /**
   * @generated from field: string guildId = 3;
   */
  guildId: string
}

/**
 * Describes the message DiscordMessageReference.
 * Use `create(DiscordMessageReferenceSchema)` to create a new message.
 */
export const DiscordMessageReferenceSchema: GenMessage<DiscordMessageReference> =
  /*@__PURE__*/
  messageDesc(file_chat_message, 8)

/**
 * @generated from message DiscordMessageAttachment
 */
export type DiscordMessageAttachment = Message<'DiscordMessageAttachment'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * @generated from field: string messageId = 2;
   */
  messageId: string

  /**
   * @generated from field: string url = 3;
   */
  url: string

  /**
   * @generated from field: string fileName = 4;
   */
  fileName: string

  /**
   * @generated from field: uint64 fileSizeBytes = 5;
   */
  fileSizeBytes: bigint

  /**
   * @generated from field: string contentType = 6;
   */
  contentType: string

  /**
   * @generated from field: bytes payload = 7;
   */
  payload: Uint8Array

  /**
   * @generated from field: string localUrl = 8;
   */
  localUrl: string
}

/**
 * Describes the message DiscordMessageAttachment.
 * Use `create(DiscordMessageAttachmentSchema)` to create a new message.
 */
export const DiscordMessageAttachmentSchema: GenMessage<DiscordMessageAttachment> =
  /*@__PURE__*/
  messageDesc(file_chat_message, 9)

/**
 * @generated from message BridgeMessage
 */
export type BridgeMessage = Message<'BridgeMessage'> & {
  /**
   * @generated from field: string bridgeName = 1;
   */
  bridgeName: string

  /**
   * @generated from field: string userName = 2;
   */
  userName: string

  /**
   * @generated from field: string userAvatar = 3;
   */
  userAvatar: string

  /**
   * @generated from field: string userID = 4;
   */
  userID: string

  /**
   * @generated from field: string content = 5;
   */
  content: string

  /**
   * @generated from field: string messageID = 6;
   */
  messageID: string

  /**
   * @generated from field: string parentMessageID = 7;
   */
  parentMessageID: string
}

/**
 * Describes the message BridgeMessage.
 * Use `create(BridgeMessageSchema)` to create a new message.
 */
export const BridgeMessageSchema: GenMessage<BridgeMessage> =
  /*@__PURE__*/
  messageDesc(file_chat_message, 10)

/**
 * @generated from message UnfurledLinkThumbnail
 */
export type UnfurledLinkThumbnail = Message<'UnfurledLinkThumbnail'> & {
  /**
   * @generated from field: bytes payload = 1;
   */
  payload: Uint8Array

  /**
   * @generated from field: uint32 width = 2;
   */
  width: number

  /**
   * @generated from field: uint32 height = 3;
   */
  height: number
}

/**
 * Describes the message UnfurledLinkThumbnail.
 * Use `create(UnfurledLinkThumbnailSchema)` to create a new message.
 */
export const UnfurledLinkThumbnailSchema: GenMessage<UnfurledLinkThumbnail> =
  /*@__PURE__*/
  messageDesc(file_chat_message, 11)

/**
 * @generated from message UnfurledLink
 */
export type UnfurledLink = Message<'UnfurledLink'> & {
  /**
   * A valid URL which uniquely identifies this link.
   *
   * @generated from field: string url = 1;
   */
  url: string

  /**
   * Website's title.
   *
   * @generated from field: string title = 2;
   */
  title: string

  /**
   * Description is sometimes available, but can be empty. Most mainstream
   * websites provide this information.
   *
   * @generated from field: string description = 3;
   */
  description: string

  /**
   * @generated from field: bytes thumbnail_payload = 4;
   */
  thumbnailPayload: Uint8Array

  /**
   * @generated from field: uint32 thumbnail_width = 5;
   */
  thumbnailWidth: number

  /**
   * @generated from field: uint32 thumbnail_height = 6;
   */
  thumbnailHeight: number

  /**
   * @generated from field: UnfurledLink.LinkType type = 7;
   */
  type: UnfurledLink_LinkType

  /**
   * @generated from field: bytes favicon_payload = 8;
   */
  faviconPayload: Uint8Array
}

/**
 * Describes the message UnfurledLink.
 * Use `create(UnfurledLinkSchema)` to create a new message.
 */
export const UnfurledLinkSchema: GenMessage<UnfurledLink> =
  /*@__PURE__*/
  messageDesc(file_chat_message, 12)

/**
 * @generated from enum UnfurledLink.LinkType
 */
export enum UnfurledLink_LinkType {
  /**
   * @generated from enum value: LINK = 0;
   */
  LINK = 0,

  /**
   * @generated from enum value: IMAGE = 1;
   */
  IMAGE = 1,
}

/**
 * Describes the enum UnfurledLink.LinkType.
 */
export const UnfurledLink_LinkTypeSchema: GenEnum<UnfurledLink_LinkType> =
  /*@__PURE__*/
  enumDesc(file_chat_message, 12, 0)

/**
 * @generated from message UnfurledStatusContactLink
 */
export type UnfurledStatusContactLink = Message<'UnfurledStatusContactLink'> & {
  /**
   * @generated from field: bytes public_key = 1;
   */
  publicKey: Uint8Array

  /**
   * @generated from field: string display_name = 2;
   */
  displayName: string

  /**
   * @generated from field: string description = 3;
   */
  description: string

  /**
   * @generated from field: UnfurledLinkThumbnail icon = 4;
   */
  icon?: UnfurledLinkThumbnail
}

/**
 * Describes the message UnfurledStatusContactLink.
 * Use `create(UnfurledStatusContactLinkSchema)` to create a new message.
 */
export const UnfurledStatusContactLinkSchema: GenMessage<UnfurledStatusContactLink> =
  /*@__PURE__*/
  messageDesc(file_chat_message, 13)

/**
 * @generated from message UnfurledStatusCommunityLink
 */
export type UnfurledStatusCommunityLink =
  Message<'UnfurledStatusCommunityLink'> & {
    /**
     * @generated from field: bytes community_id = 1;
     */
    communityId: Uint8Array

    /**
     * @generated from field: string display_name = 2;
     */
    displayName: string

    /**
     * @generated from field: string description = 3;
     */
    description: string

    /**
     * @generated from field: uint32 members_count = 4;
     */
    membersCount: number

    /**
     * @generated from field: string color = 5;
     */
    color: string

    /**
     * @generated from field: UnfurledLinkThumbnail icon = 7;
     */
    icon?: UnfurledLinkThumbnail

    /**
     * @generated from field: UnfurledLinkThumbnail banner = 8;
     */
    banner?: UnfurledLinkThumbnail
  }

/**
 * Describes the message UnfurledStatusCommunityLink.
 * Use `create(UnfurledStatusCommunityLinkSchema)` to create a new message.
 */
export const UnfurledStatusCommunityLinkSchema: GenMessage<UnfurledStatusCommunityLink> =
  /*@__PURE__*/
  messageDesc(file_chat_message, 14)

/**
 * @generated from message UnfurledStatusChannelLink
 */
export type UnfurledStatusChannelLink = Message<'UnfurledStatusChannelLink'> & {
  /**
   * @generated from field: string channel_uuid = 1;
   */
  channelUuid: string

  /**
   * @generated from field: string emoji = 2;
   */
  emoji: string

  /**
   * @generated from field: string display_name = 3;
   */
  displayName: string

  /**
   * @generated from field: string description = 4;
   */
  description: string

  /**
   * @generated from field: string color = 5;
   */
  color: string

  /**
   * @generated from field: UnfurledStatusCommunityLink community = 6;
   */
  community?: UnfurledStatusCommunityLink
}

/**
 * Describes the message UnfurledStatusChannelLink.
 * Use `create(UnfurledStatusChannelLinkSchema)` to create a new message.
 */
export const UnfurledStatusChannelLinkSchema: GenMessage<UnfurledStatusChannelLink> =
  /*@__PURE__*/
  messageDesc(file_chat_message, 15)

/**
 * @generated from message UnfurledStatusLink
 */
export type UnfurledStatusLink = Message<'UnfurledStatusLink'> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string

  /**
   * @generated from oneof UnfurledStatusLink.payload
   */
  payload:
    | {
        /**
         * @generated from field: UnfurledStatusContactLink contact = 2;
         */
        value: UnfurledStatusContactLink
        case: 'contact'
      }
    | {
        /**
         * @generated from field: UnfurledStatusCommunityLink community = 3;
         */
        value: UnfurledStatusCommunityLink
        case: 'community'
      }
    | {
        /**
         * @generated from field: UnfurledStatusChannelLink channel = 4;
         */
        value: UnfurledStatusChannelLink
        case: 'channel'
      }
    | { case: undefined; value?: undefined }
}

/**
 * Describes the message UnfurledStatusLink.
 * Use `create(UnfurledStatusLinkSchema)` to create a new message.
 */
export const UnfurledStatusLinkSchema: GenMessage<UnfurledStatusLink> =
  /*@__PURE__*/
  messageDesc(file_chat_message, 16)

/**
 * Create a wrapper around repeated property for proper unmarshalling
 *
 * @generated from message UnfurledStatusLinks
 */
export type UnfurledStatusLinks = Message<'UnfurledStatusLinks'> & {
  /**
   * @generated from field: repeated UnfurledStatusLink unfurled_status_links = 1;
   */
  unfurledStatusLinks: UnfurledStatusLink[]
}

/**
 * Describes the message UnfurledStatusLinks.
 * Use `create(UnfurledStatusLinksSchema)` to create a new message.
 */
export const UnfurledStatusLinksSchema: GenMessage<UnfurledStatusLinks> =
  /*@__PURE__*/
  messageDesc(file_chat_message, 17)

/**
 * @generated from message ChatMessage
 */
export type ChatMessage = Message<'ChatMessage'> & {
  /**
   * Lamport timestamp of the chat message
   *
   * @generated from field: uint64 clock = 1;
   */
  clock: bigint

  /**
   * Unix timestamps in milliseconds, currently not used as we use whisper as
   * more reliable, but here so that we don't rely on it
   *
   * @generated from field: uint64 timestamp = 2;
   */
  timestamp: bigint

  /**
   * Text of the message
   *
   * @generated from field: string text = 3;
   */
  text: string

  /**
   * Id of the message that we are replying to
   *
   * @generated from field: string response_to = 4;
   */
  responseTo: string

  /**
   * Ens name of the sender
   *
   * @generated from field: string ens_name = 5;
   */
  ensName: string

  /**
   * Chat id, this field is symmetric for public-chats and private group chats,
   * but asymmetric in case of one-to-ones, as the sender will use the chat-id
   * of the received, while the receiver will use the chat-id of the sender.
   * Probably should be the concatenation of sender-pk & receiver-pk in
   * alphabetical order
   *
   * @generated from field: string chat_id = 6;
   */
  chatId: string

  /**
   * The type of message (public/one-to-one/private-group-chat)
   *
   * @generated from field: MessageType message_type = 7;
   */
  messageType: MessageType

  /**
   * The type of the content of the message
   *
   * @generated from field: ChatMessage.ContentType content_type = 8;
   */
  contentType: ChatMessage_ContentType

  /**
   * @generated from oneof ChatMessage.payload
   */
  payload:
    | {
        /**
         * @generated from field: StickerMessage sticker = 9;
         */
        value: StickerMessage
        case: 'sticker'
      }
    | {
        /**
         * @generated from field: ImageMessage image = 10;
         */
        value: ImageMessage
        case: 'image'
      }
    | {
        /**
         * @generated from field: AudioMessage audio = 11;
         */
        value: AudioMessage
        case: 'audio'
      }
    | {
        /**
         * @generated from field: bytes community = 12;
         */
        value: Uint8Array
        case: 'community'
      }
    | {
        /**
         * @generated from field: DiscordMessage discord_message = 99;
         */
        value: DiscordMessage
        case: 'discordMessage'
      }
    | {
        /**
         * @generated from field: BridgeMessage bridge_message = 100;
         */
        value: BridgeMessage
        case: 'bridgeMessage'
      }
    | { case: undefined; value?: undefined }

  /**
   * Grant for community chat messages
   *
   * @generated from field: bytes grant = 13 [deprecated = true];
   * @deprecated
   */
  grant: Uint8Array

  /**
   * Message author's display name, introduced in version 1
   *
   * @generated from field: string display_name = 14;
   */
  displayName: string

  /**
   * @generated from field: ContactRequestPropagatedState contact_request_propagated_state = 15;
   */
  contactRequestPropagatedState?: ContactRequestPropagatedState

  /**
   * @generated from field: repeated UnfurledLink unfurled_links = 16;
   */
  unfurledLinks: UnfurledLink[]

  /**
   * @generated from field: Shard shard = 17;
   */
  shard?: Shard

  /**
   * @generated from field: UnfurledStatusLinks unfurled_status_links = 18;
   */
  unfurledStatusLinks?: UnfurledStatusLinks
}

/**
 * Describes the message ChatMessage.
 * Use `create(ChatMessageSchema)` to create a new message.
 */
export const ChatMessageSchema: GenMessage<ChatMessage> =
  /*@__PURE__*/
  messageDesc(file_chat_message, 18)

/**
 * @generated from enum ChatMessage.ContentType
 */
export enum ChatMessage_ContentType {
  /**
   * @generated from enum value: UNKNOWN_CONTENT_TYPE = 0;
   */
  UNKNOWN_CONTENT_TYPE = 0,

  /**
   * @generated from enum value: TEXT_PLAIN = 1;
   */
  TEXT_PLAIN = 1,

  /**
   * @generated from enum value: STICKER = 2;
   */
  STICKER = 2,

  /**
   * @generated from enum value: STATUS = 3;
   */
  STATUS = 3,

  /**
   * @generated from enum value: EMOJI = 4;
   */
  EMOJI = 4,

  /**
   * @generated from enum value: TRANSACTION_COMMAND = 5;
   */
  TRANSACTION_COMMAND = 5,

  /**
   * Only local
   *
   * @generated from enum value: SYSTEM_MESSAGE_CONTENT_PRIVATE_GROUP = 6;
   */
  SYSTEM_MESSAGE_CONTENT_PRIVATE_GROUP = 6,

  /**
   * @generated from enum value: IMAGE = 7;
   */
  IMAGE = 7,

  /**
   * @generated from enum value: AUDIO = 8;
   */
  AUDIO = 8,

  /**
   * @generated from enum value: COMMUNITY = 9;
   */
  COMMUNITY = 9,

  /**
   * Only local
   *
   * @generated from enum value: SYSTEM_MESSAGE_GAP = 10;
   */
  SYSTEM_MESSAGE_GAP = 10,

  /**
   * @generated from enum value: CONTACT_REQUEST = 11;
   */
  CONTACT_REQUEST = 11,

  /**
   * @generated from enum value: DISCORD_MESSAGE = 12;
   */
  DISCORD_MESSAGE = 12,

  /**
   * @generated from enum value: IDENTITY_VERIFICATION = 13;
   */
  IDENTITY_VERIFICATION = 13,

  /**
   * Only local
   *
   * @generated from enum value: SYSTEM_MESSAGE_PINNED_MESSAGE = 14;
   */
  SYSTEM_MESSAGE_PINNED_MESSAGE = 14,

  /**
   * Only local
   *
   * @generated from enum value: SYSTEM_MESSAGE_MUTUAL_EVENT_SENT = 15;
   */
  SYSTEM_MESSAGE_MUTUAL_EVENT_SENT = 15,

  /**
   * Only local
   *
   * @generated from enum value: SYSTEM_MESSAGE_MUTUAL_EVENT_ACCEPTED = 16;
   */
  SYSTEM_MESSAGE_MUTUAL_EVENT_ACCEPTED = 16,

  /**
   * Only local
   *
   * @generated from enum value: SYSTEM_MESSAGE_MUTUAL_EVENT_REMOVED = 17;
   */
  SYSTEM_MESSAGE_MUTUAL_EVENT_REMOVED = 17,

  /**
   * @generated from enum value: BRIDGE_MESSAGE = 18;
   */
  BRIDGE_MESSAGE = 18,
}

/**
 * Describes the enum ChatMessage.ContentType.
 */
export const ChatMessage_ContentTypeSchema: GenEnum<ChatMessage_ContentType> =
  /*@__PURE__*/
  enumDesc(file_chat_message, 18, 0)
